import React, { Component } from 'react';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';

import { StepDirection, StepSettings } from '@paragon/contract-library';
import { DistanceField } from '@paragon/material';

import { InteriorConditionSettingsPropertiesProps } from './InteriorConditionSettingsPropertiesProps';

type Props = InteriorConditionSettingsPropertiesProps<StepSettings>;

export class StepSettingsProperties extends Component<Props> {
  createSubmitHandler =
    <K extends keyof StepSettings>(key: K) =>
    (value: StepSettings[K]) => {
      this.props.onChange({ ...this.props.value, [key]: value });
    };

  createClickHandler = (value: StepDirection) => {
    this.props.onChange({ ...this.props.value, stepDirection: value });
  };

  render() {
    const { value } = this.props;

    return (
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <DistanceField
          sx={[
            value.distanceFromLeft === 0
              ? { m: 1, width: '30%', fieldSet: { borderColor: 'brand.orange' } }
              : { m: 1, width: '30%' },
          ]}
          label="Distance From Left"
          value={value.distanceFromLeft}
          onSubmit={this.createSubmitHandler('distanceFromLeft')}
        />

        <ToggleButtonGroup
          fullWidth
          sx={{ m: 1, width: '30%' }}
          size="small"
          value={value.stepDirection}
          exclusive
          aria-label="text alignment"
        >
          <ToggleButton
            onClick={() => {
              this.createClickHandler('Up');
            }}
            value="Up"
            aria-label="left aligned"
          >
            Step Up
          </ToggleButton>
          <ToggleButton
            onClick={() => {
              this.createClickHandler('Down');
            }}
            value="Down"
            aria-label="centered"
          >
            Step Down
          </ToggleButton>
        </ToggleButtonGroup>

        <DistanceField
          sx={{ m: 1, width: '30%' }}
          label="Step Distance"
          value={value.stepDistance}
          onSubmit={this.createSubmitHandler('stepDistance')}
        />
      </Box>
    );
  }
}
